import React, { useState, useRef } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import TreeView from './components/TreeView';
import AgentDetails from './components/AgentDetails';
import Header from './components/Header';
import SettingsPage from './components/SettingsPage';
import './App.css';

function App() {
  const [selectedAgentId, setSelectedAgentId] = useState(null);
  const [selectedNode, setSelectedNode] = useState(null);

  // Реф для доступа к TreeView
  const treeViewRef = useRef(null);

  const handleAgentClick = (agentId) => {
    if (agentId === null) {
      setSelectedAgentId(null);
    } else {
      setSelectedAgentId(agentId);
      setSelectedNode(null);
    }
  };

  const handleSelectNode = (node) => {
    setSelectedNode(node);
    setSelectedAgentId(null);
  };

  return (
    <Router>
      <Header />
      <div className="app-container">
        <Routes>
          <Route
            path="/tree"
            element={
              <>
                <TreeView
                  ref={treeViewRef} // Передаем ref
                  onAgentClick={handleAgentClick}
                  onSelectNode={handleSelectNode}
                />
                <AgentDetails
                  agentId={selectedAgentId}
                  selectedNode={selectedNode}
                  setSelectedAgentId={setSelectedAgentId} // Передаем функцию
                  refreshTree={() => treeViewRef.current?.fetchTreeData()} // Вызываем метод обновления
                />
              </>
            }
          />
          <Route path="/settings" element={<SettingsPage />} />
          <Route
            path="/"
            element={
              <>
                <TreeView
                  ref={treeViewRef}
                  onAgentClick={handleAgentClick}
                  onSelectNode={handleSelectNode}
                />
                <AgentDetails
                  agentId={selectedAgentId}
                  selectedNode={selectedNode}
                  setSelectedAgentId={setSelectedAgentId} // Передаем функцию
                  refreshTree={() => treeViewRef.current?.fetchTreeData()}
                />
              </>
            }
          />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
